import * as Intercom from '@intercom/messenger-js-sdk';
import { IntercomContextProvider } from '@/contexts/intercom-context/intercom-context-provider.web';
import {
  SALES_PORTAL_ENTERED_EVENT,
  useSalesPortalIntercomIdentity,
} from '@/experiences/sales-portal/contexts/use-sales-portal-intercom-identity';
import { SalesPortalIntercomProviderProps } from './sales-portal-intercom-types';

const trackSalesPortalEntered = () => {
  // Analytics only; don't block or fail boot.
  Intercom.trackEvent(SALES_PORTAL_ENTERED_EVENT);
};

/**
 * Boots the shared Intercom provider for the Sales Portal, using Sales
 * Portal's own identity source (restaurant/supplier props + AuthContext)
 * instead of the operator's UserContext-based identity.
 */
export const SalesPortalIntercomProvider: React.FC<
  SalesPortalIntercomProviderProps
> = ({ children, navigationGuardStatus, restaurantUUID, supplierUUID }) => {
  const identity = useSalesPortalIntercomIdentity({
    navigationGuardStatus,
    restaurantUUID,
    supplierUUID,
  });

  return (
    <IntercomContextProvider
      identity={identity}
      onBooted={trackSalesPortalEntered}
    >
      {children}
    </IntercomContextProvider>
  );
};
